/*
 * A&K 10.000
 * Author: Rouven Pajewski
 * Company: ActiView GmbH
 *
 * http://www.actiview.de
 */

$(document).ready(function() {
    var $window = $(window);

    // FAQ-List-Element open/close
    $('.faq-question').click(function() {
        $('.faq-answer').slideUp('fast');
        $('.faq-question .fa').removeClass('fa-minus');
        $('.faq-question .fa').addClass('fa-plus');

        if ($(this).hasClass('closed')) {
            $(this).next('.faq-answer').slideDown('fast');
            $('.faq-question').removeClass('opend');
            $('.faq-question').addClass('closed');
            $(this).toggleClass('closed opend');
            $(this).children('.fa').toggleClass('fa-plus fa-minus');
        } else {
            $('.faq-question').removeClass('opend');
            $('.faq-question').addClass('closed');
        }
    });
});